import { render, staticRenderFns } from "./ColchesterCity.vue?vue&type=template&id=a78f0a4e&scoped=true&"
import script from "./ColchesterCity.vue?vue&type=script&lang=js&"
export * from "./ColchesterCity.vue?vue&type=script&lang=js&"
import style0 from "./ColchesterCity.vue?vue&type=style&index=0&id=a78f0a4e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a78f0a4e",
  null
  
)

export default component.exports